"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrudWithListPattern = void 0;
var useCrudPattern_1 = require("./useCrudPattern");
var useFetchList_1 = require("./useFetchList");
var useCrudWithListPattern = function (api, fetchListOptions) {
    var crud = useCrudPattern_1.useCrudPattern(api);
    var list = useFetchList_1.useFetchList(api.list, fetchListOptions);
    return __assign(__assign({}, crud), { listFetchingState: list });
};
exports.useCrudWithListPattern = useCrudWithListPattern;
//# sourceMappingURL=useCrudWithListPattern.js.map